import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { homeAPI } from "../services/api";
import { PageWrapper, Card, Button, Logo } from "../components";
import { Flame } from "lucide-react";

export const PracticePage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await homeAPI.getData();
        setData(res.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <PageWrapper>
        <div className="flex items-center justify-center h-64">
          <div className="animate-pulse-gentle text-[#4A6741]">Loading...</div>
        </div>
      </PageWrapper>
    );
  }

  const practice = data?.today_practice;

  return (
    <PageWrapper>
      <div className="p-6 space-y-6 max-w-lg mx-auto">
        {/* Header with Logo */}
        <div className="flex items-center justify-center">
          <Logo size="md" variant="dark" />
        </div>

        <div className="space-y-1">
          <h1 className="font-heading text-3xl text-[#292524]">Today's Practice</h1>
          <p className="text-[#78716C]">Your daily moment of presence</p>
        </div>

        {practice ? (
          <Card className="p-5 space-y-4 animate-fade-in-up">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-[#4A6741]/10 rounded-2xl flex items-center justify-center">
                <Flame className="text-[#4A6741]" size={32} />
              </div>
              <div>
                <h3 className="font-heading text-xl text-[#292524]">{practice.title}</h3>
                <p className="text-[#78716C]">{practice.estimated_minutes} minutes</p>
              </div>
            </div>

            <p className="text-[#78716C] italic">"{practice.intention_text}"</p>

            <div className="space-y-2">
              <p className="text-sm font-medium text-[#292524]">Practice Steps:</p>
              <ul className="space-y-2">
                {practice.practice_steps?.slice(0, 3).map((step, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-[#78716C]">
                    <span className="w-5 h-5 bg-[#E6E2DD] rounded-full flex items-center justify-center flex-shrink-0 text-xs">
                      {idx + 1}
                    </span>
                    {step}
                  </li>
                ))}
              </ul>
            </div>

            <Button 
              onClick={() => navigate(`/lesson/${practice.id}?program=${data.continue_program?.id}&module=${practice.module_id}`)}
              className="w-full"
              data-testid="begin-practice-btn"
            >
              Begin Practice
            </Button>
          </Card>
        ) : (
          <Card className="p-8 text-center space-y-4">
            <div className="w-20 h-20 bg-[#E6E2DD] rounded-full flex items-center justify-center mx-auto">
              <Flame className="text-[#78716C]" size={40} />
            </div>
            <h3 className="font-heading text-xl text-[#292524]">No practice available</h3>
            <p className="text-[#78716C]">Start a program to unlock your daily practice</p>
            <Button onClick={() => navigate("/programs")} variant="outline">
              Browse Programs
            </Button>
          </Card>
        )}
      </div>
    </PageWrapper>
  );
};
